import { PHONE_REGEX } from '@/utils/regex.utils';
import { z } from 'zod';
import { branchSchema } from '../branch/branch.schema';
import { groupSchema } from '../group/group.schema';
import { userEntityRoleSchema } from '../user-entity-role/user-entity-role.schema';
import i18next from 'i18next';

export const companySchema = z.object({
  id: z.string().optional(),
  groupId: z.string().nullish(),
  name: z.string().superRefine((data, ctx) => {
    if (!data) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18next.t('common:companyNameRequired'),
      });
    }
  }),
  businessIdNumber: z.string().superRefine((data, ctx) => {
    if (!data) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18next.t('common:companyIdNumberRequired'),
      });
    }
    /* else if (!FRENCH_SIREN_REGEX.test(data)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18next.t('common:companyIdNumberFrenchIncorrect'),
      });
    } */
  }),
  addressLine1: z.string().superRefine((data, ctx) => {
    if (!data) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18next.t('common:addressLine1Required'),
      });
    }
  }),
  addressLine2: z.string().nullish(),
  state: z.string().nullish(),
  postalCode: z.string().superRefine((data, ctx) => {
    if (!data) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18next.t('common:postalCodeRequired'),
      });
    }
  }),
  city: z.string().superRefine((data, ctx) => {
    if (!data) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18next.t('common:cityRequired'),
      });
    }
  }),
  country: z.string().superRefine((data, ctx) => {
    if (!data) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18next.t('common:countryRequired'),
      });
    }
  }),
  logo: z.string().nullish(),
  phone: z.string().superRefine((data, ctx) => {
    if (!data) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18next.t('common:phoneNumberRequired'),
      });
    } else if (!PHONE_REGEX.test(data)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18next.t('common:phoneNumberIncorrect'),
      });
    }
  }),
  email: z.string().superRefine((data, ctx) => {
    if (!data) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18next.t('common:emailRequired'),
      });
    } else if (!z.string().email().safeParse(data).success) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18next.t('common:emailFormatIncorrect'),
      });
    }
  }),
  active: z.boolean().default(true),
  branches: z.lazy(() => z.array(branchSchema).nullish()).nullish(),
  group: z.lazy(() => groupSchema).nullish(),
  entityRoles: z.array(userEntityRoleSchema).nullish(),
  partFolderNotFound: z.string().nullish(),
  partContactUs: z.string().nullish(),
  proContactUs: z.string().nullish(),
});

export type TCompanySchema = z.infer<typeof companySchema>;
